/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */

import SymbolDraw from 'echarts/lib/chart/helper/SymbolDraw';
import ChartView from 'echarts/lib/view/Chart';
import GlobalModel from 'echarts/lib/model/Global';
import ExtensionAPI from 'echarts/lib/core/ExtensionAPI';
import Element from 'zrender/src/Element';
import WordCloudSeries from './WordCloudSeries';

class WordCloudView extends ChartView {
  static readonly type = 'wordCloud';

  type = WordCloudView.type;

  _finished: boolean;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  _symbolDraw: SymbolDraw;

  init(ecModel: GlobalModel, api: ExtensionAPI) {
    const symbolDraw = new SymbolDraw();
    const { group } = this;
    group.add(symbolDraw.group);
    this._symbolDraw = symbolDraw;
  }

  render(seriesModel: WordCloudSeries, ecModel: GlobalModel, api: ExtensionAPI) {
    const data = seriesModel.getData();
    const symbolDraw = this._symbolDraw;
    symbolDraw.updateData(data);
    this._finished = true;
  }

  // @ts-ignore
  eachRendered(cb: (el: Element) => boolean | void) {
    if (this._symbolDraw) {
      this._symbolDraw.eachRendered(cb);
    }
  }

  remove(ecModel: GlobalModel, api: ExtensionAPI) {
    if (this._symbolDraw) {
      this._symbolDraw.remove(true);
    }
    this._symbolDraw = null;
  }
}

export default WordCloudView;
